import type { ModalContent } from './EnablePushNotificationModal.types';

const getFallbackContent = (flag:boolean): ModalContent => {
  if (flag) {
    return {
      id: 'Unlock Savings',
      mainHeader: '💸 Unlock Savings!',
      subHeader: 'Turn on push alerts for:',
      offers: [
        {
          id: '1',
          strongtext: '10% off',
          text: 'your first $100+ order',
          subtext: '(exclusions apply)',
        },
        {
          id: '2',
          text: 'Exclusive in-app discounts',
        },
        {
          id: '3',
          text: 'Personalized deals for your vehicle',
        },
      ],
      buttons: {
        enableButtonText: 'Enable Notifications',
        dismissButtonText: 'Not Now',
      },
    };
  }
  
  return {
    id: 'Save Big',
    mainHeader: '💰 Save Big!',
    subHeader: 'Enable push notifications to unlock:',
    offers: [
      {
        id: '1',
        strongtext: '10% off',
        text: 'your first $100+ order',
        subtext: '(exclusions apply)',
      },
      {
        id: '2',
        text: 'Exclusive in-app discounts',
      },
      {
        id: '3',
        text: 'Personalized deals for your vehicle',
      },
    ],
    buttons: {
      enableButtonText: 'Enable Notifications',
      dismissButtonText: 'Not Now',
    },
  };
};

const isFlutterApp = () => {
  return typeof window !== 'undefined' && window.isFlutterApp === 'true';
};

export { getFallbackContent, isFlutterApp };
